import React, { Suspense } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import get from 'lodash/get'
import set from 'lodash/set'
import isEmpty from 'lodash/isEmpty'
import without from 'lodash/without'
import clone from 'lodash/clone'

import * as QS from 'selectors/quoteSelectors'

import Loading from 'discada/dist/Loading'

import ProgramChartFilters from 'components/Quote/ProgramChartFilters'
import FinePrint from 'components/Quote/ProgramChartFinePrint'
import { DirtyMask } from 'components/widgets/Dirty'
import Slider from 'components/Quote/SimpleQuote/Slider'

import { getPermission } from 'selectors/authSelectors'

import './ProgramChart.scss'

let kz = Object.keys

const Bubble = React.lazy(() => import('components/widgets/BubbleChart'))

export const SCENARIOS = {
  paymentByTerm: {
    label: 'Payments By Term',
  },
  residualByPayment: {
    label: 'Residual by Payment',
  },
  negativeEquity: {
    label: 'Negative Equity',
  },
  subPrime: { label: 'Sub-Prime' },
  paymentByRate: {
    label: 'Payment by Rate',
  },
  paymentByProfit: {
    label: 'Payment by Profit',
  },
}

export class Chart extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {}

    this.onClick = p =>
      this.setState({ showInfo: true, selectedProgramKey: p.programKey })
    this.unselect = () =>
      this.setState({ showInfo: false, selectedProgramKey: null })
    this.setScenario = scenarioKey => this.setState({ scenarioKey })
    this.setSliceBy = selectedSliceBy => this.setState({ selectedSliceBy })
    this.toggleFilter = (key, value) => {
      let filterGroups = clone(this.state.filterGroups),
        selected = get(filterGroups, `${key}.selected`, [])

      set(
        filterGroups,
        `${key}.selected`,
        selected.includes(value)
          ? without(selected, value)
          : [...selected, value],
      )

      this.setState({ filterGroups })
    }

    this.isOk = program => {
      let { filterGroups } = this.state

      return kz(filterGroups).every(
        k =>
          filterGroups[k].selected.length === 0 ||
          filterGroups[k].selected.includes((program[k] || '').toString()) ||
          (k === 'miles' && program.mode === 'loan'),
      )
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {
      selectedProgramKey: null,
      showInfo: false,
      selectedSliceBy: 'Lender',
      scenarioKey: 'paymentByTerm',
      filterGroups: {
        mode: { label: 'Types', selected: [] },
        term: { label: 'Terms', selected: [] },
        down: { label: 'Amount Down', selected: [] },
        creditScore: { label: 'Credit Tiers', selected: [] },
        miles: { label: 'Miles', selected: [] },
        Lender: { label: 'Lender', selected: [] },
      },
      sliceBy: {
        Lender: 'Lender',
        modeLabel: 'Program Type',
        advanceOk: 'Advance',
      },
      ...state,
      programs: props.programs,
      nearest: props.getNearest(state.filterGroups),
    }
  }

  render() {
    let { vehicleId, quoteId, mode, bestProgramKey } = this.props,
      {
        selectedProgramKey,
        programs,
        filterGroups,
        selectedSliceBy,
        sliceBy,
        scenarioKey,
        nearest,
        showInfo,
      } = this.state,
      programKey = showInfo
        ? selectedProgramKey || nearest.key || bestProgramKey
        : null

    return (
      <div className="program-chart-outer">
        <div className="program-chart-wrapper">
          <DirtyMask vehicleId={vehicleId} quoteId={quoteId} />
          <Slider
            vehicleId={vehicleId}
            quoteId={quoteId}
            filters={QS.convertFilterGroupsToFilters(filterGroups)}
            programKey={programKey}
            onChange={() => this.setState({ showInfo: true })}
          />
          <div className="chart-inner">
            <Suspense fallback={<Loading />}>
              <Bubble
                vehicleId={vehicleId}
                quoteId={quoteId}
                programs={programs}
                filterGroups={filterGroups}
                onClick={this.onClick}
                isOk={this.isOk}
                groupBy={selectedSliceBy}
                scenarioKey={scenarioKey}
              />
            </Suspense>

            <div
              className={c('program-filter-wrapper', {
                'showing-program': !isEmpty(selectedProgramKey),
              })}
            >
              {showInfo ? (
                <FinePrint
                  vehicleId={vehicleId}
                  quoteId={quoteId}
                  mode={mode}
                  programKey={programKey}
                  unselect={this.unselect}
                />
              ) : (
                <ProgramChartFilters
                  vehicleId={vehicleId}
                  quoteId={quoteId}
                  className={c({ fade: !isEmpty(selectedProgramKey) })}
                  allPrograms={programs}
                  toggleFilter={this.toggleFilter}
                  setScenario={this.setScenario}
                  setSliceBy={this.setSliceBy}
                  filterGroups={filterGroups}
                  selectedSliceBy={selectedSliceBy}
                  scenarioKey={scenarioKey}
                  sliceBy={sliceBy}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let desiredPayment = QS.getQuoteValue(
    state,
    op.vehicleId,
    op.quoteId,
    'desiredPayment',
  )

  return {
    ...op,
    show: getPermission(state, 'deal.fields/profit'),
    bestProgramKey: QS.getBestProgramKey(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
    ),
    programs: QS.getQuoteValue(state, op.vehicleId, op.quoteId, 'programs', {}),
    getNearest: filters => {
      return QS.findNearestProgram(
        state,
        op.vehicleId,
        op.quoteId,
        desiredPayment,
        QS.convertFilterGroupsToFilters(filters),
      )
    },
  }
}

export default connect(
  mapStateToProps,
  {},
  null,
)(Chart)
